<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button class="btn primary" :disabled="!isShowStart" type="primary" size="small" v-preventReClick
            @click="handleCommand('start', checkData)">启用</el-button>
          <el-button class="btn" size="small" :disabled="!isShowStop" v-preventReClick
            @click="handleCommand('stop', checkData)">禁用</el-button>
          <ExcelImport v-auth:[moduleCode]="'Import'" style="height: 32px;margin-left: 10px;">
          </ExcelImport>
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="exportData" style="margin-left: 10px;">导出</el-button>
            <el-input :class="{'days-disabled':!checkData||checkData.length<=0}" :disabled="!checkData||checkData.length<=0" style="width: 280px;margin:0 10px;" v-model="daysNum" placeholder="请输入效期提醒天数">
              <template #append><el-button :disabled="!checkData||checkData.length<=0"  @click="handleDays" class="btn primary" type="primary" >效期提醒设置</el-button></template>
            </el-input>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">自定义设置</el-button> -->
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%"
        @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column v-for="item in column" :key="item.id" :width="item.width" show-overflow-tooltip
          :prop="item.code" :label="item.name">
          <template #default="scope" v-if="!item.slot">
            <span>{{ scope.row[item.code] }}</span>
          </template>
          <template #default="scope" v-else>
            <span v-if="item.code == 'Name'" class="name" v-preventReClick @click="handleStartInfo(scope.row)">{{
              scope.row[item.code] }}</span>
            <span v-if="item.code == 'StartStopStatus'">{{ scope.row[item.code] ? '启用' : '禁用' }}</span>
            <span v-if="item.code != 'Name' && item.code != 'StartStopStatus'">{{ scope.row[item.code] ? '是' : '否' }}</span>
          </template>

        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
              @click="handleStartUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-dropdown class="more-box margin-left20 color-blue"
              @command="(command) => { handleCommand(command, [scope.row]) }">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="copyAdd">复制并新增</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.StartStopStatus" command="stop">禁用</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.StartStopStatus" command="start">启用</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total"
        @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="visible" title="禁用理由" width="500" class="custom-reason-dialog"
      :before-close="handleClose">
      <el-form class="custom-reason-form" label-position="top" ref="formRef" :model="modelForm" :rules="modelRules">
        <el-form-item label="禁用理由" prop="reason">
          <el-input v-model="modelForm.reason" :placeholder="'请填写禁用理由'" type="textarea" resize="none" :rows="5"
            style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确认</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  RemoveProductUpdates,
  GetTableShowSet,
  GetPage,
  GetQueryType,
  GetMedicationType,
  ExportMedInfo,
  MedicationInfoEnable,
  MedicationInfoDisable,
  GetMeddInfoSupplier,
  GetBulkSetERODByDay
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from '@/mixin/baseList-mixin.js'
import ExcelImport from '@/components/ExcelImport/index.vue'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    SelectFilter,
    ExcelImport
  },
  data() {
    return {
      GetDatasAction: GetPage,
      RemoveAction: RemoveProductUpdates,
      exportAction: ExportMedInfo,
      editPath: 'drugInfoMaintain-edit',
      infoPath: 'drugInfoMaintain-info',
      filterOptions: [
        {
          name: "药品编码",
          type: "input",
          code: "No",
        },
        {
          name: "药品名称",
          type: "input",
          code: "Name",
        },
        {
          name: "通用名",
          type: "input",
          code: "CommonName",
        },
        {
          name: "药品类型",
          type: "select",
          code: "DrugType",
          data: []
        },
        {
          name: "药品规格",
          type: "input",
          code: "Specifications",
        },
        {
          name: "通用名",
          type: "input",
          code: "commonName",
        },
        {
          name: "药品类型",
          type: "select",
          code: "drugTypeName",
          filterMethod: () => this.getEnum('CASL.Model.CASLModel.Enum.Drug.DrugType'),
          data: [],
        },
        {
          name: "药品规格",
          type: "input",
          code: "specifications",
        },
      ],
      column: [],
      tableSlot: [
        {
          code: 'Name', // 药品名称
        },
        {
          code: 'IsValuable', // 是否贵重药品
        },
        {
          code: 'IsPrescription', // 是否处方药品
        },
        {
          code: 'IsHighWarning', // 是否高警示药品
        },
        {
          code: 'IsControl', // 是否管控药品
        },
        {
          code: 'IsInSC', // 是否川产
        },
        {
          code: 'IsNeedSensitivity', // 是否需要试敏
        },
        {
          code: 'IsNewDrug', // 是否新药
        },
        {
          code: 'IsBasicMedicine', // 是否基药
        },
        {
          code: 'IsAnestheticDrug', // 是否麻醉药品
        },
        {
          code: 'IsToxicDrug', // 是否毒性药品
        },
        {
          code: 'IsPsychotropicDrug', // 是否精神类药品
        },
        {
          code: 'IsRadioactiveDrug', // 是否放射性药
        },
        {
          code: 'IsAntibacterialDrug', // 是否抗菌药品
        },
        {
          code: 'IsAntibioticDrug', // 是否抗生素药品
        },
        {
          code: 'IsAntibioticDrug', // 是否激素药品
        },
        {
          code: 'IsLargeInfusionDrugs', // 是否大输液药品
        },
        {
          code: 'IsDigestiveDrugs', // 是否消化药物
        },
        {
          code: 'IsAntitumorDrugs', // 是否抗肿瘤药物
        },
        {
          code: 'IsCVDrugs', // 是否心脑血管药物
        },
        {
          code: 'IsEpDrugs', // 是否防疫药品
        },
        {
          code: 'IsNutritionalDrugs', // 是否防疫药品
        },
        {
          code: 'IsPreparation', // 是否防疫药品
        },
        {
          code: 'IsCharge', // 是否防疫药品
        },
        {
          code: 'IsInCabinet', // 是否防疫药品
        },
        {
          code: 'IsHanging', // 是否防疫药品
        },
        {
          code: 'StartStopStatus', // 启停状态
        },
      ],
      checkData: [],
      isShowStop: false, // 是否显示停用
      isShowStart: false, // 是否显示启用
      query: {
        keyWord: "",
        pageSize: 20,
        pageIndex: 1,
        name: '',
        no: ''
      },
      queryType: 1,
      // 新增queryTypeList用于存储接口返回的字段配置
      queryTypeList: [],
      visible: false,
      modelForm: {
        reason: ''
      },
      modelRules: {
        reason: [{ required: true, message: '请填写禁用理由', trigger: 'change' }],
      },
      medicationInfoIds: [],
      moduleCode: 'MedicationInfo',
      daysNum:null
    };
  },
  methods: {

    // 获取枚举数据
    async getEnum (val) {
      const query = {
        name:val
      }
      const res = await GetEnumDescriptions(query)
      return res.returnData
    },

    // 获取表格头部
    async getHeaderData() {
      const query = {
        moduleCode: 'MedicationInfo',
        TableIsChk: 1
      }
      const res = await GetTableShowSet(query)
      this.column = res.map(item => ({
        id: item.id,
        code: item?.fieldName,
        name: item.showName,
        slot: this.tableSlot.find(slot => slot.code === item.fieldName) ? true : false,
      }))

    },
    filterChange(query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    // 重置
    reset() {
      // this.query.keyWord = "";
      // this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 20);
      // this.ids = []
      // this.multipleSelection = []
      // this.multiple = true;
      this.query = {
        keyWord: "",
        pageSize: 20,
        pageIndex: 1,
        name: '',
        no: '',
        orgCode :sessionStorage.getItem('orgId')
      };

      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    // 选择更多
    async handleCommand(command, row) {
      this.medicationInfoIds = row.map(item => item.Id)
      switch (command) {
        case 'copyAdd':
          this.handleCopyAdd({ id: row[0].Id })
          break;
        case 'stop':
          GetMeddInfoSupplier({ medicationInfoIds: [row[0].Id] }).then(res => {
            if (res.returnData.isUse) {
              const supplierNamesArr = res.returnData?.subViews[0]?.supplierNames || []
              const supplierNames = supplierNamesArr.map(item => `【${item}】`).join('、');
              this.$my_confirm(`供应商${supplierNames}正在使用该药品，禁用后,正在使用的供应商不能继续使用该用品!`, "提示", {
                type: "warning",
              }).then(async () => {
                this.visible = true
              }).catch((error) => {
                this.visible = false
              });
            } else {
              this.visible = true
            }
          })
          break;
        case 'start':
          this.$my_confirm("此操作将启用该药品，是否继续？", "提示", {
            type: "warning",
          }).then(async () => {
            try {
              await MedicationInfoEnable({ medicationInfoIds: this.medicationInfoIds })
              this.getData();
              if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
              }
              this.$my_message(`启用成功！`, "success");
            } catch (error) {
              this.$my_message(`启用失败！${error}`, "error");
            }
          }).catch((error) => {
            this.$my_message(`启用失败！${error}`, "error");
          });
          break;

        default:
          break;
      }
    },
    handleStartUpdate(row) {
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 2, id: row.Id });
    },
    handleStartInfo(row) {
      this.routePushWithParams("/" + this.infoPath, this.query, { formMode: 0, id: row.Id });
    },
    handleSelectionChange(val) {
      this.checkData = val
      if(val&&val.length>0){
        this.isShowStop = val.every(item => item.StartStopStatus == true)
        this.isShowStart = val.every(item => item.StartStopStatus == false)
      }else{
        this.isShowStop = false
        this.isShowStart = false
      }
      
    },
    async handleDays(){
      if(!this.daysNum){
        this.$my_message(`请输入批量设置近效期提醒天数！`, "warning");
        return
      }
      const ids = this.checkData.map(item => item.Id)
      try {
        await GetBulkSetERODByDay({medicationInfoIds:ids,erodByDay:this.daysNum})
         this.getData();
         this.daysNum = null
        this.$my_message(`批量设置近效期提醒天数成功！`, "success");
      } catch (error) {
        this.daysNum = null
        this.$my_message(`设置失败！${error}`, "error");
      }
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleClose() {
      this.$refs.formRef.resetFields()
      this.visible = false
    },
    async handleSubmit() {
      if (!this.$refs.formRef) return
      try {
        await MedicationInfoDisable({ medicationInfoIds: this.medicationInfoIds, disableReason: this.modelForm.reason })
        this.getData();
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection()
        }
        this.$my_message(`禁用成功！`, "success");
        this.visible = false
      } catch (error) {
        this.$my_message(`禁用失败！${error}`, "error");
      }
    },
    // 获取 queryType
    async fetchQueryType() {
      // console.log('开始');
      try {
        const res = await GetQueryType({ moduleCode: 'MedicationInfo' });
        // console.log('返回结果:', res);
        this.queryTypeList = res || []; // 存储接口返回的字段配置
        // console.log('字段配置获取成功:', this.queryTypeList);
      } catch (error) {
        console.log('获取字段配置失败:', error);
        this.queryTypeList = [];
      }
      // console.log('结束');
    },
    async getData() {
      const conditions = [];

      // 遍历过滤条件动态生成查询参数
      this.filterOptions.forEach(option => {
        const queryKey = option.code;
        // console.log('queryKey:', queryKey);
        const value = this.query[queryKey];
        // console.log('value:', value);
        // console.log('this.query:', this.query);

        if (value) {
          // 查找字段对应的配置信息
          const fieldConfig = this.queryTypeList.find(
            item => item.fieldName === option.code

          );
          // console.log('fieldConfig:', fieldConfig);

          // 构建条件对象
          conditions.push({
            colName: option.code,
            value: value,
            queryType: fieldConfig ? fieldConfig.queryType : 1 // 默认queryType为1
          });
        }
      });

      // 构造请求参数（保持其他参数不变）
      const params = {
        loginDeptId: this.query.loginDeptId,
        loginWarehouseId: this.query.loginWarehouseId,
        pageSize: this.query.pageSize,
        pageIndex: this.query.pageIndex,
        conditions: conditions
      };
      // console.log('请求参数:',params);

      // 保持原有数据获取逻辑
      try {
        const res = await this.GetDatasAction(params);
        this.tableData = res.returnData?.data || [];
        this.total = res.returnData?.totalCount || 0;
      } catch (error) {
        console.log('数据获取失败:', error);
        this.tableData = [];
        this.total = 0;
      }
    },
    async getMedicationType() {
      try {
        const res = await GetMedicationType({ name: 'CASL.Model.CASLModel.Enum.Drug.DrugType' });
        // console.log('获取药品类型成功:', res);
        return res.returnData
      } catch (error) {
        console.error('获取药品类型失败:', error);
        return [];
      }
    }
  },

  async mounted() {
    await this.fetchQueryType(); // 先获取字段配置
    await this.getHeaderData();

    // 获取药品类型数据
    const drugTypes = await this.getMedicationType();
    const drugTypeOption = this.filterOptions.find(option => option.code === 'DrugType');
    if (drugTypeOption) {
      drugTypeOption.data = drugTypes; // 将药品类型数据赋值给 filterOptions
    }

    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.name {
  color: #409EFF;
  cursor: pointer;
}

.more-box {
  cursor: pointer;
}
:deep(.el-input-group__append){
  background: #017DFF;
  color: white;
  border: 0;
  border-radius: 0;
  font-weight: 400;
  &:hover{
    background-color: #017DFF;
    box-shadow: 0px 3px 6px #abafbf;
    opacity: 0.7;
  }
  .el-button--primary:hover{
    background: transparent;
    box-shadow:0;
    opacity:1
  }
}
.days-disabled{
  :deep(.el-input-group__append){
    &:hover{
      background-color: #94b5da;
      box-shadow: none;
    }
  }
}



// .el-dropdown-link {
//     cursor: pointer;
//     color: #286ac5;
//   }
//   .el-icon-arrow-down {
//     font-size: 12px;
//   }
</style>
